/**
 * Extracts the country code from a locale string.
 * Pure module — no store, reducer, or API imports (safe for Vitest pure unit tests).
 *
 * @param {string | null | undefined} [value] - Locale (e.g. "en-US").
 * @returns {string} Country code (e.g. "USA", "GB").
 */
export function getCountryFromLocale(value) {
    if (!value) {
        return 'USA';
    }

    const hyphenIndex = value.indexOf('-');

    if (hyphenIndex !== -1) {
        const country = value.substring(hyphenIndex + 1);

        return country === 'US' ? 'USA' : country.toUpperCase();
    }

    return 'USA';
}

export default getCountryFromLocale;
